var _rect, _rect2, _rect3, _rect4, _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptyStateShifts(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 60,
    viewBox: "0 0 62 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51.892,
    height: 60,
    rx: 1.822,
    fill: "#EAEAFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.865,
    y: 11.351,
    width: 42.162,
    height: 6.486,
    rx: 0.271,
    fill: "#D8D9FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.865,
    y: 22.703,
    width: 42.162,
    height: 6.486,
    rx: 0.271,
    fill: "#D8D9FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.865,
    y: 34.054,
    width: 42.162,
    height: 6.486,
    rx: 0.271,
    fill: "#D8D9FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.078,
    cy: 44.594,
    r: 10.54,
    fill: "#A1A3F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.402 44.594h11.352M51.078 38.919v11.35",
    stroke: "#fff",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateShifts);
export default __webpack_public_path__ + "static/media/empty-state-shifts.61943503.svg";
export { ForwardRef as ReactComponent };